import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./routes";
import { ThemesProvider, TitleProvider } from "./shared/contexts";
import { UsuarioLogadoInfoReservaProvider } from "./shared/contexts/UsuarioLogadoInfoReservaContext";

const queryClient = new QueryClient();

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TitleProvider>
        <ThemesProvider>
          <UsuarioLogadoInfoReservaProvider>
            <BrowserRouter basename="">
              <AppRoutes />
            </BrowserRouter>
          </UsuarioLogadoInfoReservaProvider>
        </ThemesProvider>
      </TitleProvider>
    </QueryClientProvider>
  );
};
